 export const baseURL= "https://development.roamjssln.com"
 //export const baseURL= "https://admin.roamjssln.com"

//export const baseURL= "http://192.168.29.201:5000"
//config endpoint
export const auth={
    SEND_OTP:baseURL+"/api/auth/send-otp",
    VERIFY_OTP:baseURL+"/api/auth/verify-otp",
    GET_PTOFILE:baseURL+"/api/users/profile",
    EDIT_PROFILE:baseURL+"/api/users/profile",
    LOGOUT_USER:baseURL+"/api/auth/logout",
    BOOKING_HISTORY:baseURL+"/api/bookings/history",
    termAndConditions:baseURL+'/api/users/terms'
}

export const buses={
    SEARCH_BUSES:baseURL+"/api/buses/search",
    BUS_DETAILS:baseURL+"/api/buses/",
    BOOK_BUS:baseURL+"/api/bookings",
    BOOK_DETAILS:baseURL+"/api/bookings/",
    GET_COUPON:baseURL+'/api/admin/coupons',
    APPLY_COUPON:baseURL+'/api/bookings/apply',
    SEARCH_CITIES:baseURL+'/api/buses/cities/search'
}